import request from '@/utils/requestun' // 引入封装的request.js文件

// 获取资源
export function getDatabankList(query) {
  return request({
    url: '/databank/lists',
    method: 'get',
    params: query
  })
}

// 获取资源详情
export function getDatabankDetail(query) {
  return request({
    url: '/databank/info',
    method: 'get',
    params: query
  })
}